import { render, staticRenderFns } from "./ParamManage.vue?vue&type=template&id=2af4cefe&scoped=true"
import script from "./ParamManage.vue?vue&type=script&lang=js"
export * from "./ParamManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af4cefe",
  null
  
)

export default component.exports